import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { FinancialStatementTwoYearsAgoFullYearRuleset } from '../../business/ruleset';
import { taxDocuments } from '../../form_models/loanFormModel';

const { financialStatementTwoYearsAgoFullYear } = taxDocuments;

export class FinancialStatementTwoYearsAgoFullYearValidation
  implements ValidationSchema
{
  public name = financialStatementTwoYearsAgoFullYear.name;
  public label =
    financialStatementTwoYearsAgoFullYear.getLabel(defaultApplicantName);
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = FinancialStatementTwoYearsAgoFullYearRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    return FileNameValidationSchema(
      financialStatementTwoYearsAgoFullYear.name,
      required
    );
  }
}
export default new Validation(
  new FinancialStatementTwoYearsAgoFullYearValidation()
);
